class GetPaymentPixError extends Error {
  constructor(cause, url, props, code = 'GET_PAYMENT_PIX_ERROR') {
    super("Falha ao gerar pagamento por pix");
    this.name = 'GetPaymentPixError';
    this.code = code;
    this.cause = cause;
    this.url = url;
    this.props = props;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GetPaymentPixError);
    }
  }
}

module.exports = GetPaymentPixError;